import L from "leaflet";

const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = "",
  entity = ""
) => {
  //---------------allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    // let isInCluster = false;
    // const clusterChildMarkers = cluster.getAllChildMarkers();
    // if (selectedInstitution) {
    //   for (const clusterChildMarker of clusterChildMarkers) {
    //     if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
    //       isInCluster = true;
    //       //cluster.spiderfy();
    //     }
    //   }
    // }

    return L.divIcon({
      // Cluster icon
      html: `
      <div class="markerIcon">
              <svg version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/"
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
              style="enable-background:new 0 0 40 40;" xml:space="preserve">
                <path class="st0" d="M33.3,15.2c0-7.4-6-13.3-13.3-13.3S6.7,7.8,6.7,15.2c0,3.7,1.5,7.1,4,9.5c2.5,2.5,4.8,5.8,6.5,8.5S20,38,20,38
                  s1.1-2.1,2.8-4.8c1.7-2.7,4-6.1,6.5-8.5S33.3,18.9,33.3,15.2z M20,20.6c-2.9,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2
                  s5.2,2.3,5.2,5.2C25.2,18.2,22.9,20.6,20,20.6z"/>
                <circle cx="20" cy="15.4" r="8.1"/>
              </svg>
              <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
            <div class="pulse"></div>
      </div>
            `,
      iconSize: L.point(40, 40, true),
      className: "custom-marker-cluster",
    });
  } else {
    // One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin ${isSelected ? "active" : ""}`,
      // ${entity?.activity.indexOf("produit") !== -1 ? "contact-pin" : ""}`
      iconSize: [40, 40], // size of the icon
      iconAnchor: [20, 40],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -40],
      html: `
      <div class="markerIcon">
        <svg version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
        width="40px" height="40px"
        style="enable-background:new 0 0 40 40;" xml:space="preserve">
          <path class="st0" fill="${entity?.tags[0].color}" d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4
            c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z
            "/>
        </svg>
      <div class="pulse"></div>
      </div>
      `,
    });
    return icon1;
  }
};

export default MarkerIcon;
